var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 21.12 120 42.24 120 64 C80.4 64 40.8 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#294B75",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 9.9 120 19.8 120 30 C80.4 30 40.8 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "#F8EAEE",
    transform: "translate(0,34)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 4.95 120 9.9 120 15 C80.4 15 40.8 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#B7254C",
    transform: "translate(0,34)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 7.92 72 15.84 72 24 C48.24 24 24.48 24 0 24 C0 16.08 0 8.16 0 0 Z ",
    fill: "#B92D52",
    transform: "translate(48,5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 1.98 120 3.96 120 6 C80.4 6 40.8 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#B6244B",
    transform: "translate(0,58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 3.3 72 6.6 72 10 C48.24 10 24.48 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#B92C52",
    transform: "translate(48,5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 1.65 120 3.3 120 5 C80.4 5 40.8 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F8EBEF",
    transform: "translate(0,44)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 1.65 120 3.3 120 5 C80.4 5 40.8 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FCF8F9",
    transform: "translate(0,34)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 1.32 120 2.64 120 4 C80.4 4 40.8 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#B31942",
    transform: "translate(0,49)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 1.65 72 3.3 72 5 C48.24 5 24.48 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#B51F47",
    transform: "translate(48,29)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 1.65 72 3.3 72 5 C48.24 5 24.48 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FAF1F4",
    transform: "translate(48,24)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 1.65 72 3.3 72 5 C48.24 5 24.48 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FAF2F4",
    transform: "translate(48,5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 1.65 72 3.3 72 5 C48.24 5 24.48 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#B51F47",
    transform: "translate(48,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.76 0 47.52 0 72 0 C72 1.32 72 2.64 72 4 C48.24 4 24.48 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(48,15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.49f0c7fd787541e2c93932e7d3e794aa.svg";
export { ForwardRef as ReactComponent };